
import svgIconList from 'assets/icons.json';
import { EventEmitterService } from '@core/services/event-emitter.service';
import { ChangeDetectorRef,   Component, OnInit} from '@angular/core';
import { Router } from '@angular/router';
import { GameCategoryHttpService } from '@core/services/game-category-http.service';
import { MatDialog } from '@angular/material/dialog';
import { LoginModalComponent } from '@shared/login-modal/login-modal.component';
import { CountDownDetailsComponent } from '@shared/count-down/dialog/count-down-details/count-down-details.component';
import { GameListHttpService } from '@core/services/game-list-http.service';
import { tap } from 'rxjs/operators';
import { SeoService } from '@core/services/seo.service';
import { OwlOptions } from 'ngx-owl-carousel-o';
import { environment } from '@env/environment';

@Component({
  selector: 'app-jackpot-slider',
  templateUrl: './jackpot-slider.component.html',
  styleUrls: ['./jackpot-slider.component.scss'],
})
export class JackpotSliderComponent implements OnInit {
  svg: any = svgIconList;

  odometerConfig = {
    animation: 'slide',
    format: '(,ddd).dd',
    theme: 'default',
    auto: true
  }

  availableProvider = JSON.parse(localStorage.getItem('available_providers'));
  SGisActive = false; 
  PTisActive = false;

  gameCodeByJacpot = {
    ADV: 'S-PO02',
    CJ: 'S-EG02',
    MGC: 'S-LB01',
    GJ: 'S-DG03',
    FUFU: 'S-FO01'
  };

  gameCodeByJacpotPt = {
    'jpgt6-1':  'jpgt',
    'ashlcl-1': 'ashlcl',
    'ashbob-1':  'ashbob',
    cnpr4:   'cnpr',
    kfp:   'kfp',
    'dcjp-4' : 'gpas_etpop_pop',
    'pisa' : 'pisa',
    'bjp-4' : 'gpas_bprog_pop',
  };

  gameCodeByJacpotPostionPt = [
    'jpgt6-1', // 1
    // 'ashlcl-1', // 2
    // 'ashbob-1', // 3
    'cnpr4', // 4
    // 'kfp', // 5
    'dcjp-4', // 6
    'pisa', // 7
    'bjp-4', // 8
  ];

  jackpot = [];
  gameList  = {};
  gameProvider :any;
  gameListPt = {};
  ptgamelistcheck = false

  countryCode = localStorage.getItem('country_code')?.toUpperCase();
  curentTime :any;

  contentHash = '';

  dateNow: any;
  dateEnd: any;

  gameCodeByJacpotPostion = [
    'MGC', // 1
    'FUFU', // 2
    'ADV', // 3
    'GJ', // 4
    'CJ' // 5
  ];

  customOptionsJacpot: OwlOptions = {
    loop: true,
    mouseDrag: true,
    touchDrag: true,
    pullDrag: false,
    dots: true,
    navSpeed: 1000,
    autoplaySpeed: 1000,
    autoplay: true,
    items: 1,
    nav: false,
    animateOut: 'animate__animated animate__slideOutLeft',
  };

  constructor(
    private eventEmitterService: EventEmitterService,
    private router: Router,
    private gameCategoryHttpService: GameCategoryHttpService,
    public dialog: MatDialog,
    private gameListHttpService: GameListHttpService,
    private seoService: SeoService,
    private cdr: ChangeDetectorRef
  ) { }

  ngOnInit() {
    if(this.availableProvider && this.availableProvider['SL'].find(x => x.game_provider_code == 'SG')) {
      this.SGisActive = true;
      this.gameProvider = this.availableProvider['SL'].find(x => x.game_provider_code == 'SG');
    }

    if(this.availableProvider && this.availableProvider['SL'].find(x => x.game_provider_code == 'PTI') || !environment.production ) {
      this.PTisActive = true;
      this.gameProvider = this.availableProvider['SL'].find(x => x.game_provider_code == 'PTI');
    }

    this.getGameList();
    this.getGameListPT();
    //for testing number update
    // var plus = 0;
    this.eventEmitterService.jackpotDataEventEmitter.subscribe(data => {
      data = this.formDataArray(data['jackpot']);
      if(!this.availableProvider) {
        this.availableProvider = JSON.parse(localStorage.getItem('available_providers'));
        if (this.onGetCurrencyCode() == 'SGD'){
          this.gameProvider = this.availableProvider['SL'].find(x => x.game_provider_code == 'SG');
          this.SGisActive = true;
        }else{
          this.gameProvider = this.availableProvider['SL'].find(x => x.game_provider_code == 'PTI');
          this.PTisActive = true;
        }
      }

      if (this.onGetCurrencyCode() == 'SGD' && this.SGisActive == false ){
        this.gameProvider = this.availableProvider['SL'].find(x => x.game_provider_code == 'SG');
        this.SGisActive = true;
      }else{
        if( this.PTisActive == false && this.availableProvider && this.availableProvider['SL'].find(x => x.game_provider_code == 'PTI') || !environment.production ){
          this.gameProvider = this.availableProvider['SL'].find(x => x.game_provider_code == 'PTI');
          this.PTisActive = true;
        }
      }

      if(this.jackpot.length == 0) {
        this.jackpot = data;
      }else{
        // update only amount, instead array due to the slider will re-render problem
        if(this.jackpot.length > 0 && data.length  > 0){
          let jackpotlist = this.jackpot;
          Object.keys(jackpotlist).forEach(function (key) {
            //for testing number update
            // plus = plus + 5;
            // data['jackpot']['data'][key]['amount']['MYR'] = data['jackpot']['data'][key]['amount']['MYR'] + plus;  

            // only amount different only will update
            if( JSON.stringify(data[key]['amount']) !== JSON.stringify(jackpotlist[key]['amount']) ){
              jackpotlist[key]['amount'] = data[key]['amount'];
            }
          });
          this.jackpot = jackpotlist;
        }
      }
    });
  }

  getOffset(el: any) {
    el = el.getBoundingClientRect();
    return {
      left: el.left + window.scrollX,
      top: el.top + window.scrollY,
      bottom: el.top + window.scrollY
    };
  }

  scroll() {
    const scrollTo = document.getElementById('content');
    const topHight = this.getOffset(scrollTo).top;
    window.scrollTo(0, topHight);
  }


  onLaunchGame(data: any,  gameProvider ,isDemo = false) {
    if(gameProvider == 'SG'){
      var gameCode = this.gameList[this.gameCodeByJacpot[data]]['code'];
    }else{
      var gameCode = this.gameListPt[this.removeFormat(this.gameCodeByJacpotPt[data])]['code'];
    }

    // To update the params on the URL
    window.history.replaceState({}, '', `/slots-game/${('Spade Gaming').replace(/\s/g, '').toLowerCase()}`);
    // Need to manually trigger seoService since we manually update the url without doing routing
    this.seoService.execute();
    var item = this.gameProvider;

    this.dateEnd = Date.parse(item.maintain_end);
    this.dateNow = new Date().getTime();

    if (localStorage.getItem('user_data') === null) {
      this.openDialogBy(LoginModalComponent);
    } else if (item.maintenance === 1 && item.code !== null && this.dateEnd > this.dateNow) {
      this.contentHash = Math.random().toString(36).substring(7);
      this.dialog.open(CountDownDetailsComponent, {
        width: '400px',
        data: {
          dateEnd: item.maintain_end,
          name: item.game_provider_name,
          time: item.maintain_time_left,
        }
      });
    } else if (item.maintenance === 1 && gameCode !== null && item.maintain_time_left === '') {
      this.contentHash = Math.random().toString(36).substring(7);
      this.dialog.open(CountDownDetailsComponent, {
        width: '400px',
        data: {
          name: item.game_provider_name,
          time: item.maintain_time_left,
        }
      });
    } else {
      localStorage.setItem('gameProviderCode', gameProvider);
      localStorage.setItem('gameProviderId', item.game_provider_id);
      localStorage.setItem('gameCode', gameCode);
      localStorage.setItem('gameCategory', 'SL');
      localStorage.setItem('gameType', 'SLOTS');
      localStorage.setItem('gameMode', 'real');
      localStorage.setItem('lobbyUrl', location.href);
      // localStorage.setItem('isPlayTechClicked', (gameProvider === "PTI").toString());
      localStorage.setItem('gameMode', 'real');  
      this.onLaunchGameBy(item, gameCode, 'SLOTS', isDemo);
    }
  }  

  onLaunchGameBy(item: any, gameCode: string, gameType: string, isDemo = false, slotsType?: string) {
    if (gameCode !== null && slotsType !== 'APP') {
      const userData = JSON.parse(localStorage.getItem('user_data') || '{}');
      const redirectUsers = JSON.parse(localStorage.getItem('whitelist_game_launch') || '{}');;
      const username = userData?.username;
      const iframeProviders = JSON.parse(localStorage.getItem('whitelist_game_provider') || '{}');
      const currentGame = localStorage.getItem('gameProviderCode') || null;

      // Define the users who should be redirected
      if (username && (redirectUsers.includes(username) || iframeProviders.includes(currentGame))) {
        this.router.navigate([]).then(() => { window.open('/gamelaunch', '_self'); });
      }
      else {
        this.router.navigate([]).then(() => { window.open('/gamelaunch', '_blank'); });
      }
    } else {
      this.router.navigate(['/slots-game/' + (item.game_provider_name).replace(/\s/g, '').toLowerCase()], { state: { item: item, slotsType: slotsType } });
    }  
  }  

  onGetCurrencyCode() {
     let currency_code =  null;

    if (localStorage.getItem('country_code')?.toUpperCase() == 'MY') {
      currency_code = 'MYR';
    } else if (localStorage.getItem('country_code')?.toUpperCase() == 'SG') {
      currency_code = 'SGD';
    } else if (localStorage.getItem('country_code')?.toUpperCase() == 'ID') {
      currency_code = 'IDR';
    } else if (localStorage.getItem('country_code')?.toUpperCase() == 'TH') {
      currency_code = 'THB';
    } else if (localStorage.getItem('country_code')?.toUpperCase() == 'VN') {
      currency_code = 'VND';
    } else if (localStorage.getItem('country_code')?.toUpperCase() == 'PH') {
      currency_code = 'PHP';
    } else if (localStorage.getItem('country_code')?.toUpperCase() == 'AU') {
      currency_code = 'AUD';
    }

    return currency_code;
  }

  transferAmount(data){
    let amount = +parseFloat(data).toFixed(2);

    //Workaround to deal with floating point arithmetic issue
    if (Math.round(amount * 100) % 10 == 0) {
      amount = amount + 0.01
    }

    return amount;
  }

  getGameList() {
      var games = {};
      // hard code to get Spade game,slot gamelist
      this.gameListHttpService.getGamesBy('SG', 'SL').pipe(
        tap(res => {
          Object.keys(res).forEach(function (key) {
            if(res[key]['status'] == "ACTIVE") games[res[key]['code']]  = res[key];
          });
          this.gameList = games;
        })
      ).subscribe();
  }

  private openDialogBy(componentRef: any) {
    this.dialog.open(componentRef);
  }

  getGameListPT() {

    var games = {};
    // hard code to get Playtech game , for qa testing
    if (!environment.production) {
      games['jpgt'] = {
          "code":  "jpgt",
          "GameProviderCode" : "PTI"
      };
      games['ashlcl'] = {
        "code":  "ashlcl",
        "GameProviderCode" : "PTI"
      };
      games['cnpr'] = {
          "code":  "cnpr",
          "GameProviderCode" : "PTI"
      };
      games['kfp'] = {
        "code":  "kfp",
        "GameProviderCode" : "PTI"
      };
      games['ashbob'] = {
        "code":  "ashbob",
        "GameProviderCode" : "PTI"
      };
      games['gpas_etpop_pop'] = {
        "code":  "gpas_etpop_pop",
        "GameProviderCode" : "PTI"
      };
      games['pisa'] = {
        "code":  "pisa",
        "GameProviderCode" : "PTI"
      };
      games['gpas_bprog_pop'] = {
        "code":  "gpas_bprog_pop",
        "GameProviderCode" : "PTI"
      };

      this.gameListPt = games;

    }else{
      this.gameListHttpService.getGamesBy('PTI', 'SL').pipe(
      tap(res => {
        Object.keys(res).forEach(function (key) {
          if(res[key]['status'] == "ACTIVE") games[res[key]['code']]  = res[key];
        });
        this.gameListPt = games;
      })
    ).subscribe();
    }

  }

  formDataArray(data) {
    var games = [];
    Object.keys(data).forEach(element => {
      Object.keys(data[element]['data']).forEach(element2 => {
        data[element]['data'][element2]['GameProviderCode'] = element;
        games.push(data[element]['data'][element2]);
      }); 
    });
    return games;
  }

  removeFormat(data){
    return data.replace('-1', '') as string;
  }

  checkPTgame(){

    if(this.ptgamelistcheck){
      return true;
    }
    var checkPt = false
    if( this.jackpot && this.jackpot.length > 0 ){
      var jackpotlist = this.jackpot;
      var gameCodeByJacpotPostionPt  = this.gameCodeByJacpotPostionPt;
      
      Object.keys(gameCodeByJacpotPostionPt).forEach(function (key) {
        Object.keys(jackpotlist).forEach(element2 => {
          if(jackpotlist[element2]['code'] == gameCodeByJacpotPostionPt[key]){
            checkPt = true;
          }
        }); 
      });
    }

    if(checkPt){
      this.ptgamelistcheck = true;
      return true;
    }
  
    return false;
  }
}
